import { css } from "@emotion/css";

export const createPasswordInputStyles = () => ({
  root: css({
    display: "flex",
    padding: 0,
    border: 0,
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
  }),
  icon: css({
    width: 24,
    height: 24,
  }),
});
